// controllers/auto_dismiss_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        delay: { type: Number, default: 3000 },
        duration: { type: Number, default: 200 },
    }

    connect() {
        this.timeout = setTimeout(() => {
            this.dismiss()
        }, this.delayValue)
    }

    disconnect() {
        clearTimeout(this.timeout)
    }

    dismiss() {
        // enable fade
        this.element.classList.add("transition-opacity")
        this.element.classList.add("opacity-0")

        // remove after fade
        setTimeout(() => {
            this.element.remove()
        }, this.durationValue)
    }
}